import {
	GetMigratableTenantRequest,
	MigratableTenant,
	MigrateTenantsRequest,
} from '../types';
import apiClient from './apiClient';

const MIGRATE_KEY = 'migrate';

const getMigratableTenants = async (request: GetMigratableTenantRequest) => {
	const response = await apiClient.post<MigratableTenant[]>(
		'/auth/migration/getMigratableTenants',
		request,
	);
	return response.data;
};

const migrateTenant = async (request: MigrateTenantsRequest) => {
	const response = await apiClient.post<MigratableTenant[]>(
		'/auth/migration/migrateTenants',
		request,
	);
	return response.data;
};

const MigrateApi = {
	getMigratableTenants,
	migrateTenant,
	MIGRATE_KEY,
};

export default MigrateApi;
